var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
export var createNativeMediaRecorderFactory = function (createNotSupportedError) { return function (nativeMediaRecorderConstructor, stream, mediaRecorderOptions) {
    var bufferedBlobEventListeners = new Map();
    var dataAvailableListeners = new WeakMap();
    var errorListeners = new WeakMap();
    var flags = [];
    var nativeMediaRecorder = new nativeMediaRecorderConstructor(stream, mediaRecorderOptions);
    var stopListeners = new WeakMap();
    nativeMediaRecorder.addEventListener('stop', function (_a) {
        var isTrusted = _a.isTrusted;
        if (isTrusted) {
            setTimeout(function () { return flags.shift(); });
        }
    });
    nativeMediaRecorder.addEventListener = (function (addEventListener) {
        return function (type, listener, options) {
            var patchedEventListener = listener;
            if (typeof listener === 'function') {
                if (type === 'dataavailable') {
                    var bufferedBlobEvents_1 = [];
                    // Bug #20: Firefox dispatches multiple dataavailable events while being inactive.
                    patchedEventListener = function (event) {
                        var _a = __read(flags, 1), _b = _a[0], _c = _b === void 0 ? [false, false] : _b, _d = __read(_c, 2), isSliced = _d[0], isActive = _d[1];
                        if (isSliced && !isActive) {
                            bufferedBlobEvents_1.push(event);
                        }
                        else {
                            listener.call(nativeMediaRecorder, event);
                        }
                    };
                    bufferedBlobEventListeners.set(listener, bufferedBlobEvents_1);
                    dataAvailableListeners.set(listener, patchedEventListener);
                }
                else if (type === 'error') {
                    // Bug #12 & #13: Firefox fires a regular event with an error property.
                    patchedEventListener = function (event) {
                        if (event instanceof ErrorEvent) {
                            listener.call(nativeMediaRecorder, event);
                        }
                        else {
                            listener.call(nativeMediaRecorder, new ErrorEvent('error', { error: event.error }));
                        }
                    };
                    errorListeners.set(listener, patchedEventListener);
                }
                else if (type === 'stop') {
                    // Bug #20: Firefox dispatches multiple dataavailable events while being inactive.
                    patchedEventListener = function (event) {
                        var e_1, _a;
                        try {
                            for (var _b = __values(bufferedBlobEventListeners.entries()), _c = _b.next(); !_c.done; _c = _b.next()) {
                                var _d = __read(_c.value, 2), dataAvailableListener = _d[0], bufferedBlobEvents = _d[1];
                                if (bufferedBlobEvents.length > 0) {
                                    var _e = __read(bufferedBlobEvents, 1), blobEvent = _e[0];
                                    if (bufferedBlobEvents.length > 1) {
                                        Object.defineProperty(blobEvent, 'data', {
                                            value: new Blob(bufferedBlobEvents.map(function (_a) {
                                                var data = _a.data;
                                                return data;
                                            }), { type: blobEvent.data.type })
                                        });
                                    }
                                    bufferedBlobEvents.length = 0;
                                    dataAvailableListener.call(nativeMediaRecorder, blobEvent);
                                }
                            }
                        }
                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
                        finally {
                            try {
                                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                            }
                            finally { if (e_1) throw e_1.error; }
                        }
                        listener.call(nativeMediaRecorder, event);
                    };
                    stopListeners.set(listener, patchedEventListener);
                }
            }
            return addEventListener.call(nativeMediaRecorder, type, patchedEventListener, options);
        };
    })(nativeMediaRecorder.addEventListener);
    nativeMediaRecorder.removeEventListener = (function (removeEventListener) {
        return function (type, listener, options) {
            var patchedEventListener = listener;
            if (typeof listener === 'function') {
                if (type === 'dataavailable') {
                    bufferedBlobEventListeners.delete(listener);
                    var dataAvailableListener = dataAvailableListeners.get(listener);
                    if (dataAvailableListener !== undefined) {
                        patchedEventListener = dataAvailableListener;
                    }
                }
                else if (type === 'error') {
                    var errorListener = errorListeners.get(listener);
                    if (errorListener !== undefined) {
                        patchedEventListener = errorListener;
                    }
                }
                else if (type === 'stop') {
                    var stopListener = stopListeners.get(listener);
                    if (stopListener !== undefined) {
                        patchedEventListener = stopListener;
                    }
                }
            }
            return removeEventListener.call(nativeMediaRecorder, type, patchedEventListener, options);
        };
    })(nativeMediaRecorder.removeEventListener);
    nativeMediaRecorder.start = (function (start) {
        return function (timeslice) {
            /*
             * Bug #6: Safari will emit a blob without any data when asked to encode a MediaStream with a video track into an audio
             * codec.
             */
            if (mediaRecorderOptions.mimeType !== undefined &&
                mediaRecorderOptions.mimeType.startsWith('audio/') &&
                stream.getVideoTracks().length > 0) {
                throw createNotSupportedError();
            }
            if (nativeMediaRecorder.state === 'inactive') {
                flags.push([timeslice !== undefined, true]);
            }
            return timeslice === undefined ? start.call(nativeMediaRecorder) : start.call(nativeMediaRecorder, timeslice);
        };
    })(nativeMediaRecorder.start);
    nativeMediaRecorder.stop = (function (stop) {
        return function () {
            if (nativeMediaRecorder.state !== 'inactive') {
                flags[0][1] = false;
            }
            stop.call(nativeMediaRecorder);
        };
    })(nativeMediaRecorder.stop);
    return nativeMediaRecorder;
}; };
//# sourceMappingURL=native-media-recorder-factory.js.map
